module.exports = __webpack_public_path__ + "11_hige_black.f86dea94.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer3/11_hige_black.png
// module id = 32wY
// module chunks = 0